module.exports = __webpack_public_path__ + "static/media/christmas-carol-2024.3598f6c0.jpg";